import { createContext } from 'react';

export const PopoverMenuContext = createContext({});

const PopoverMenuContextProvider = ({ value = {}, children }) => (
  <PopoverMenuContext.Provider value={value}>
    {children}
  </PopoverMenuContext.Provider>
);

export default PopoverMenuContextProvider;
